import messageService from "../../services/messageService";
import { getField, updateField } from "vuex-map-fields";

const state = {
  messages: [],
  contentTypes: []
};

const getters = {
  getField,
  messages: state => {
    return state.messages;
  }
};

const actions = {
  fetchMessages({ commit }, payload) {
    return messageService.fetchMessages(payload).then(response => {
      commit("SET_MESSAGES", response.data);
    });
  },
  sendMessage({ commit }, payload) {
    return messageService.postMessage(payload).then(response => {
      commit("ADD_MESSAGE", response.data);
    });
  },
  async getContentTypes({ commit }) {
    let contentTypes = await messageService.getContentType();
    commit("SET_CONTENT_TYPES", contentTypes);
  }
};

const mutations = {
  updateField,
  SET_MESSAGES(state, messages) {
    state.messages = messages;
  },
  ADD_MESSAGE(state, message) {
    state.messages.push(message);
  },
  SET_CONTENT_TYPES(state, contentTypes) {
    state.contentTypes = contentTypes;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
